module.exports = __webpack_public_path__ + "static/team_meeting_graph-316cb4ddbd22fbbb7b46cf5fb0d80583.svg";